import { Component, OnInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { SharedService } from 'src/app/services/sharedService';
import { UserSessionService } from 'src/app/services/usersession.service';
import { NotifypopupComponent } from '../../pages/master/notifypopup/notifypopup.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit {

  isLoading: boolean;
  client: any;
  clientIdlocalStorage: string;
  clientId: any;
  showallMenu: boolean = false
  role: any;
  message: any;

  constructor(private router: Router,
    private sharedService: SharedService,
    private authService: AuthenticationService,
    public dialog: MatDialog,
    private usersessionService: UserSessionService) {
    this.role = this.usersessionService.roleId()
    // Spinner for lazyload modules
    router.events.forEach((event) => {

      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }

    });


    this.sharedService.changeEmitted$.subscribe((data: any) => {
      this.clientIdlocalStorage = localStorage.getItem('clientId');
      if (this.clientIdlocalStorage == '--All--' && this.role == 1) {
        this.showallMenu = true
      }
      else {
        this.showallMenu = false
      }
    });

    this.clientIdlocalStorage = localStorage.getItem('clientId');
    if (this.clientIdlocalStorage == '--All--' && this.role == 1) {
      this.showallMenu = true
    }
    else {
      this.showallMenu = false
    }
  }

  ngOnInit(): void {
    this.notify()
  }

  notify() {
    if (!localStorage.getItem('view_notifypopup') && localStorage.getItem('isLoggedin')) {
      var data = {
        keys: ["cardholder_announcement"]
      }
      this.authService.getNotification(data).subscribe((res) => {
        this.message = res.cardholder_announcement.slice(15)
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90%' : screenWidth < 1024 ? '70%' : '50%';
        if (this.message) {
          localStorage.setItem('view_notifypopup', 'true')
          const dialogRef = this.dialog.open(NotifypopupComponent, {
            width: dialogWidth,
            height: 'auto',
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog-notify_popup',
          });
        }
      })
    }

  }


}
